<button
  class="pagination-button"
  [class.pagination-button--selected]="selected()"
  (click)="onClick()"
>
  {{ page() }}
</button>
